import { useAtomValue } from 'jotai';

import { templateCreationRecordIdAtom } from '../atoms';
import { getTemplateBuilderPorts } from '../template-builder-ports';
import { useQueryTemplateCreationRecordById } from './queries/useQueryTemplateCreationRecordById';
export const useTemplateFromTemplateCreationRecordId = () => {
  const templateCreationRecordId = useAtomValue(templateCreationRecordIdAtom);
  const { data: templateCreationRecord } = useQueryTemplateCreationRecordById({
    templateCreationRecordId,
    select: (data) => {
      return {
        templateId: data.template_creation_record.template_id,
      };
    },
  });
  const { data: template } = getTemplateBuilderPorts().useQueryTemplateById(
    templateCreationRecord?.templateId,
    null
  );
  return template;
};
